import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  // const offers = [protiumDemoOffer];
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const [leadData, setLeadDate] = useState({});
  const [failedList, setFailedList] = useState([]);
  const ldId = params.get("ld_id") || "";
  const utmMedium = params.get("utm_medium") || "";

  const [ipAddress, setIpAddress] = useState("");

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data?.ip);
        console.log("IP Address:", data?.ip);
        console.log(ipAddress);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }

  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    if (formData.fetchedLeadId && !leadId) {
      setLeadId(formData.fetchedLeadId);
      setTimeout(() => {
        fetchOffers(formData.fetchedLeadId);
      }, 6000);
    }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(true);
    } else {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];
        const mergedLenders = [...apiLenders];
        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "submit-prefr-v1-lead",
      user_id: ldId || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_medium: utmMedium,
    });
    try {
      const leadResponse = await callApi(
        "v1/lead/lead-from-phone",
        "post",
        {
          phone: mobile,
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          kyc_consent: isTncChecked,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "core",
        token,
      );

      if (leadResponse["status"] === "Success" && leadResponse.data.lead) {
        const leadData = leadResponse.data.lead;
        setLeadDate(leadData);
        const coreLeadCheck = await callApi(
          "v1/lead/list",
          "post",
          {
            filters: {
              _id: leadData._id,
            },
          },
          "core",
        );
        setTimeout(() => {
          fetchOffers(leadData._id);
        }, 6000);
      } else {
        navigate(`/personal-loan?source=${source}`);
      }
    } catch (error) {
      console.log("Error fetching lead or calling APIs:", error);
      setIsFinished(true);
      navigate(`/personal-loan?source=${source}`);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    const TARGET_LENDER_ID = "667ffb7b0dd50ee1bb6556c5";
    const startTime = Date.now();

    try {
      // 1️⃣ Fetch offers + active lenders in parallel
      const [offerRes, lenderRes] = await Promise.all([
        callApi(
          `v1/loan_offer/lead_id/${leadId}`,
          "get",
          {},
          "core",
          user.token,
        ),
        callApi(`v1/lender/active-lenders`, "get", {}, "loan", user.token),
      ]);

      let filteredOffers = [];

      if (
        offerRes.status === "Success" &&
        offerRes.data?.offers?.length > 0 &&
        lenderRes.status === "Success"
      ) {
        const offers = offerRes.data.offers;
        const apiLenders = lenderRes.data.lenderList ?? [];

        // 2️⃣ Fetch success/fail lender list
        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
          "post",
          {},
          "loan",
          user.token,
        );

        if (Array.isArray(lenderListRes.data?.FailList)) {
          setFailedList(lenderListRes.data.FailList);
        }

        const successLenders =
          lenderListRes.status === "Success" &&
          Array.isArray(lenderListRes.data?.Successlist)
            ? lenderListRes.data.Successlist
            : [];

        // 🔑 only proceed if the target lender is in success list
        const isTargetLenderSuccess = successLenders.some(
          (lender) => lender.lender_id === TARGET_LENDER_ID,
        );

        if (isTargetLenderSuccess) {
          // 3️⃣ merge lenders
          const mergedLenders = [
            ...apiLenders.map((l) => ({ ...l, lender_id: l._id })),
            ...successLenders,
          ];

          // 4️⃣ create lender map
          const lenderMap = Object.fromEntries(
            mergedLenders.map((lender) => [lender.lender_id, lender]),
          );

          // 5️⃣ enrich offers
          const enrichedOffers = offers.map((offer) => {
            const lender = lenderMap[offer.lender_id] || {};
            return {
              ...offer,
              apr: lender.apr ?? "",
              kfs_doc: lender.kfs_doc ?? "",
              credit_limit: lender.web_offer ?? "",
              penal_charges: lender.penal_charges ?? "",
              processing_fee: lender.processing_fee ?? "",
              interest_rate: lender.web_interest ?? null,
              lender_name: lender.lender_name ?? offer.lender_name,
            };
          });

          // 6️⃣ sort offers
          const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

          // 7️⃣ filter — only show the Prefr Preapproved offer (single)
          const prefrOffers = sortedOffers.filter(
            (offer) => offer.lender_id === TARGET_LENDER_ID,
          );
          filteredOffers = prefrOffers.length > 0 ? [prefrOffers[0]] : [];
        }
        // else: target lender not in success list → filteredOffers stays empty → "no offer" state
      }

      const elapsedTime = Date.now() - startTime;
      const remainingDelay = Math.max(5000 - elapsedTime, 0);

      setTimeout(() => {
        dispatch(setOffers(filteredOffers));
        setIsFinished(true);
      }, remainingDelay);

      return true;
    } catch (err) {
      console.error("Error in offer fetching", err);
      setTimeout(() => {
        setIsFinished(true);
      }, 5000);
      return false;
    }
  };

  return (
    <div id="offer-page-v5">
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              {/* <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              /> */}
              <div className="offer-page-logo-wrapper">
                <img
                  src="/assets/img/newLogo.png"
                  alt="DigitMoney Logo"
                  className="offer-page-top-logo"
                />
              </div>
              <img
                src="/assets/img/offerbgimg.png"
                alt="Square Check Background"
                className="background-overlay-img-offer-pf"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text1-pf">Congratulations!</h2>
              <h3 className="sub-text1-pf">You're Pre-Qualified for a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container-new1-pf">
            {offers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={true}
                onExpand={() => {}}
              />
            ))}

            <p className="disclaimer-offer-new-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text1">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(false) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(false) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;